import styled from 'styled-components/macro'

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Image = styled.img`
  width: auto;
  height: 160px;
  margin: 60px 42px 42px;
`

export { Image, ImageContainer }
